@forward '@raspberrypifoundation/design-system-core/scss/properties/colors/greys';
@forward '@raspberrypifoundation/design-system-core/scss/properties/colors/text';
@forward '@raspberrypifoundation/design-system-core/scss/properties/spacing';
@forward '@raspberrypifoundation/design-system-core/scss/properties/border';
@forward '@raspberrypifoundation/design-system-core/scss/components/button';
@forward '@raspberrypifoundation/design-system-core/scss/components/burger-menu';
@forward '@raspberrypifoundation/design-system-core/scss/components/link.scss';
@forward '@raspberrypifoundation/design-system-core/scss/properties/colors/brand';
@forward '@raspberrypifoundation/design-system-core/scss/properties/sizing';
@forward '../../global/styles';

:host {
  --nav-background: var(--rpf-white);
  --focus-border-color: var(--rpf-brand-raspberry);
  --text-color: var(--rpf-text-primary);
  --button-font-size: var(--font-size-1-5);

  position: relative;
  z-index: 9999;
}

:host([theme='dark']) {
  --nav-background: var(--rpf-grey-850);
  --focus-border-color: var(--rpf-white);
  --text-color: var(--rpf-text-primary-darkmode);
  --link-color: var(--rpf-white);

  .rpf-burger-menu {
    --rpf-burger-menu-background-color: var(--rpf-white);
  }

  .rpf-button {
    --rpf-button-border-color: var(--rpf-white);
    --rpf-button-border-color-hover: var(--rpf-white);
  }
}

.rpf-org-nav {
  align-items: center;
  background: var(--nav-background);
  block-size: 64px;
  box-sizing: border-box;
  container-type: inline-size;
  display: flex;
  justify-content: space-between;
  padding-block: var(--space-0-5);
  padding-inline-end: var(--space-1);
  padding-inline-start: var(--space-2);
  position: relative;

  &__nav {
    &--sm {
      background: var(--nav-background);
      border-block-start: 1px solid var(--rpf-grey-150-50);
      box-sizing: border-box;
      display: none;
      flex-direction: column;
      inset-block-start: 64px;
      inset-inline: 0;
      min-block-size: calc(100vh - 64px);
      padding-block: var(--space-2);
      padding-inline: var(--space-3);
      position: absolute;

      .open & {
        display: flex;
      }
    }

    &--lg {
      display: none;
    }

    @container (min-width: 77.5rem) {
      &--sm {
        display: none;

        .open & {
          display: none;
        }
      }

      &--lg {
        display: flex;
      }
    }
  }

  &__button {
    font-size: var(--font-size-1-5);

    &::before {
      inset: calc((var(--min-target-size) - 36px) / 2) 0;
    }

    &:focus-visible {
      &::before {
        outline: solid var(--border-width-md) var(--focus-border-color);
      }
    }

    @container (max-width: 77.5rem) {
      margin-inline-start: auto;
    }
  }

  &__menu {
    @container (min-width: 77.5rem) {
      display: none;
    }
  }

  &__start-slot,
  &__end-slot {
    align-items: center;
    display: flex;
  }

  &__start-slot {
    gap: var(--space-4);

    @container (max-width: 77.5rem) {
      gap: var(--space-1);
      inline-size: 100%;
    }
  }

  &__end-slot {
    display: none;
    min-inline-size: 200px;

    @container (min-width: 77.5rem) {
      display: flex;
    }
  }
}

.site-header-skipper {
  margin: 0;
  position: relative;
}

.site-header-skipper__item {
  list-style: none;

  &:not(:focus-within) {
    block-size: 1px !important;
    clip: rect(0 0 0 0) !important;
    clip-path: inset(100%) !important;
    inline-size: 1px !important;
    overflow: hidden !important;
    position: absolute !important;
    white-space: nowrap !important;
  }
}

.site-header-skipper__link {
  background: var(--nav-background);
  font-size: var(--font-size-1-5);
  inset-block-start: 5rem;
  inset-inline-start: var(--space-2);
  outline-offset: 3px;
  padding: var(--space-1-5);
  position: absolute;
  z-index: 2000;
}
